<template>
  <!-- <div v-if="!createdOrganization">-->
  <div>
    <div class="container">
      <span class="form-title"><span>{{ adminText('organizationAll.create_6e157c5d', 'Create') }}</span><span>{{ adminText('organizationAll.organization_7cb06027', 'organization') }}</span></span>
      <form v-scroll-to-error @keydown.enter.prevent="">
        <div class="steps">
          <span :class="activeStep === 1 ? 'curr-step' : 'prev-step'"> {{ adminText('organizationAll.1_organization_info_fde8c9d4', '1. Organization info') }} </span>
          <hr :class="activeStep > 1 ? 'hr-active' : 'hr'">
          <span :class="['step', activeStep == 2 && 'curr-step']">
            {{ adminText('organizationAll.2_organization_finance_info_bdfe34f5', '2. Organization finance info') }}
          </span>
          <!-- <hr :class="activeStep > 2 ? 'hr-active' : 'hr'" />
          <span :class="['step', activeStep == 3 && 'curr-step']">
            3. Terms of use
          </span> -->
        </div>
        <organization-info-form v-if="activeStep === 1" :initial-values="form" :vs="$v" />
        <organization-finance-info-form v-if="activeStep === 2" :initial-values="form" :vs="$v" />
        <!-- <organization-terms-of-use-form v-if="activeStep === 3" :initial-values="form" :vs="$v" />-->
        <div class="buttons-wrapper">
          <main-button class="back-btn" flat :text="adminText('organizationAll.cancel_1507c40f', 'CANCEL')" @click="handleCancel()" />
          <div class="buttons">
            <main-button
              v-if="activeStep > 1"
              class="continue-btn"
              depressed
              color="#0277BD"
              flat
              :outline="true"
              @click="activeStep = activeStep - 1"
            >
              <v-icon class="arrow-back">arrow_back</v-icon>
              <span>{{ adminText('organizationAll.back_61bb8d29', 'back') }}</span>
            </main-button>
            <main-button
              class="continue-btn"
              depressed
              :disabled="uploadInProgress || !isFormValid"
              @click="activeStep === 1 ? (activeStep = 2) : submitForm()"
            >
              <span>{{ activeStep === 2 ? adminText('organizationAll.create_organization_d6890289', 'create organization') : adminText('organizationAll.continue_eee0bbba', 'continue') }}</span>
              <v-icon v-if="activeStep !== 2" class="arrow">arrow_forward</v-icon>
            </main-button>
          </div>
        </div>
      </form>
    </div>
    <simple-snackbar v-bind.sync="snackbar" :message-prop="organizationText(snackbar &amp;&amp; (snackbar.messageProp || snackbar.message))" />
  </div>
  <!-- <organization-created-message v-else :createdOrganization="createdOrganization" /> -->
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { required, email } from 'vuelidate/lib/validators'
import { submitGuard } from './../../utils'
import { httpUrl } from '@/validators'
import {
  CREATE_ORGANIZATION,
  GET_ORGANIZATIONS,
  CHECK_FOR_ORGANIZATION_WITH_SAME_FINANCE_INFO,
} from '../../graphql/organization.graphql'

import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import OrganizationInfoForm from './organization-info-form.vue'
import OrganizationFinanceInfoForm from './organization-finance-info-form.vue'
import { EventBus } from '@/plugins/event-bus.js'
// import OrganizationTermsOfUseForm from './organization-terms-of-use-form.vue'
// import OrganizationCreatedMessage from './organization-created-message.vue'
import { OrganizationType } from '@/types'
import { capitalize, toUpper } from 'lodash'

export default {
  mixins: [OrganizationLocalization],
  name: 'organization-create-container',
  components: {
    SimpleSnackbar,
    OrganizationInfoForm,
    OrganizationFinanceInfoForm,
    // OrganizationTermsOfUseForm,
    // OrganizationCreatedMessage,
  },
  data() {
    return {
      activeStep: 1,
      snackbar: {},
      form: {
        publicName: null,
        type: capitalize(OrganizationType.REGULAR),
        email: null,
        logo: null,
        description: null,
        facebookLink: null,
        instagramLink: null,
        linkedinLink: null,
        youtubeLink: null,
        webLink: null,
        legalName: null,
        OIB: null,
        primaryEmail: null,
        contactNumber: null,
        authorizedPerson: null,
        IBAN: null,
        address: null,
        city: null,
        postalCode: null,
        VATObligor: false,
        EInvoiceEnabled: false,
        // acceptedContract1: false,
        // acceptedContract2: false,
      },
      uploadInProgress: false,
      //createdOrganization: null,
    }
  },
  validations() {
    return {
      form: {
        publicName: { required },
        type: { required },
        email: { required, email },
        legalName: { required },
        OIB: { required },
        authorizedPerson: { required },
        address: { required },
        city: { required },
        postalCode: { required },
        IBAN: { required },
        primaryEmail: { required, email },
        contactNumber: { required },
        description: { required },
        facebookLink: { httpUrl },
        instagramLink: { httpUrl },
        linkedinLink: { httpUrl },
        youtubeLink: { httpUrl },
        webLink: { httpUrl },
        VATObligor: { required },
      },
    }
  },
  computed: {
    isFormValid() {
      const mandatoryFields = this.activeStep === 1
        ? ['publicName', 'email', 'description']
        : ['legalName', 'OIB', 'IBAN', 'authorizedPerson', 'address', 'city', 'postalCode', 'VATObligor', 'primaryEmail', 'contactNumber']

      const hasErrors = mandatoryFields.some(key => {
        const field = this.$v.form && this.$v.form[key]

        return field ? field.$error || field.$invalid : true
      })

      return !hasErrors
    },
  },
  mounted() {
    EventBus.$on('upload-in-progress', this.handleLogoUploadInProgress)
  },
  destroyed() {
    EventBus.$off('upload-in-progress', this.handleLogoUploadInProgress)
  },
  methods: {
    handleLogoUploadInProgress(inProgress) {
      this.uploadInProgress = inProgress
    },
    openSnackBar() {
      this.showErrorMsg = true
      setTimeout(() => (this.showErrorMsg = false), 3000)
    },
    handleCancel() {
      this.goTo(this.routes.organizer.organizations)
    },
    // goToOrganization() {
    //   if (this.createdOrganization.type === OrganizationType.THEATER) {
    //     this.goTo(this.routes.main.theaterOrganizationSidebar, {
    //       organizationSlug: this.createdOrganization.slug,
    //     })
    //   } else {
    //     this.goTo(this.routes.main.organizationSidebar, {
    //       organizationSlug: this.createdOrganization.slug,
    //     })
    //   }
    // },
    // async nextStep() {
    //   if(this.activeStep === 1) {
    //     this.activeStep = 2
    //   } else {
    //     this.$v.form.$touch()
    //     if (this.$v.form.$invalid === true) {
    //       this.snackbar = {
    //         open: true,
    //         messageProp: 'Fill in the required information to continue',
    //         color: 'error',
    //       }
    //     } else {
    //       const { data: { checkIfOrganizationWithSameFinanceInfoExists: orgOibExists } } = await this.$apollo.query({
    //         query: CHECK_FOR_ORGANIZATION_WITH_SAME_FINANCE_INFO,
    //         variables: { oib: this.form.OIB },
    //       })
    //       if (orgOibExists) {
    //         this.submitForm()
    //       }
    //       else this.activeStep = 3
    //     }
    //   }
    // },
    async submitForm() {
      this.$v.form.$touch()
      // if (this.activeStep === 3 && (!this.form.acceptedContract1 || !this.form.acceptedContract2)) {
      //   this.snackbar = {
      //     open: true,
      //     messageProp: 'You must accept the contracts to create organization.',
      //     color: 'error',
      //   }
      // } else if (this.activeStep === 2 && this.$v.form.$invalid === true) {
      //   this.snackbar = {
      //     open: true,
      //     messageProp: 'Fill in the required information to continue',
      //     color: 'error',
      //   }
      if (this.$v.form.$invalid === true) {
        this.snackbar = {
          open: true,
          messageProp: 'Fill in the required information.',
          color: 'error',
        }
      } else {
        await submitGuard(this, async () => {
          const organizationInfo = {
            ...this.form,
            EInvoiceEnabled: this.form.VATObligor ? true : this.form.EInvoiceEnabled,
            type: toUpper(this.form.type.replace(/ /g, '_')),
          }
          //const { acceptedContract1, acceptedContract2, ...rest } = this.form
          const { data, errors } = await this.$apollo.mutate({
            mutation: CREATE_ORGANIZATION,
            variables: {
              organizationInfo,
            },
            refetchQueries: [{ query: GET_ORGANIZATIONS }],
          })

          if (errors) {
            this.snackbar = {
              open: true,
              messageProp: errors[0].message,
              color: 'error',
            }
          } else {
            //this.createdOrganization = data.createOrganization
            this.goTo(this.routes.organizer.organizations, { organizationCreated: true })
          }
        })
      }
    },
  },
}
</script>

<style scoped>
.form-title {
  height: fit-content;
  color: #ff4c00;
  display: flex;
  flex-direction: column;
  font-family: 'Raleway', sans-serif;
  font-size: 2.25rem;
  font-weight: bold;
  margin-right: 3rem;
}
.container {
  padding-top: 0.75rem !important;
  display: flex;
}
form {
  width: 100%;
}
.steps {
  font-family: 'Raleway';
  margin-bottom: 2rem;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  color: #d9d9d9;
  user-select: none;
}
.curr-step {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  color: #0277bd !important;
  margin-bottom: 0.75rem;
}
.prev-step {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  color: #979797 !important;
}
.hr {
  width: 2.25rem;
  height: 0.25rem;
  display: inline-block;
  background: #d9d9d9;
  border: none;
  border-radius: 0.5rem;
  vertical-align: middle;
  margin: 0 0.75rem;
}
.hr-active {
  width: 2.25rem;
  height: 0.25rem;
  border: none;
  border-radius: 0.5rem;
  display: inline-block;
  background: #979797;
  vertical-align: middle;
  margin: 0 0.75rem;
}
.category-text {
  max-width: 50rem;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  margin-bottom: 1.5rem;
  margin-top: 0.75rem;
  color: #666666;
}
@media screen and (max-width: 960px) {
  .container {
    display: flex;
    padding: 2rem;
    flex-direction: column;
  }
  .form-title {
    margin-bottom: 1.5rem;
    column-gap: 0.5rem;
    flex-direction: row;
  }
}
@media screen and (min-width: 1904px) {
  .container {
    max-width: 74.063rem !important;
  }
}

.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 2rem;
}
@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }
  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}
.arrow {
  margin-left: 0.625rem;
}
.arrow-back {
  margin-right: 0.625rem;
}
</style>
